import { Store, Building2, ClipboardList, PackagePlus, RefreshCw, PackageOpen, Boxes, CalendarClock, TrendingUp } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const items = [
  { icon: Store, title: "Abastecimiento para sucursales", text: "Surtido continuo para cada punto de venta de su cadena." },
  { icon: Building2, title: "Compras centralizadas", text: "Un solo interlocutor para todas sus unidades de negocio." },
  { icon: ClipboardList, title: "Compras por proyecto", text: "Equipamiento completo por licitación o proyecto especial." },
  { icon: PackagePlus, title: "Apertura de nuevas tiendas", text: "Paquetes tecnológicos llave en mano para aperturas." },
  { icon: RefreshCw, title: "Renovación tecnológica", text: "Actualización de parque tecnológico por etapas." },
  { icon: PackageOpen, title: "Reposición de equipos", text: "Reemplazo ágil de equipos dañados u obsoletos." },
  { icon: Boxes, title: "Compras por volumen", text: "Escalas de precio competitivas para grandes pedidos." },
  { icon: CalendarClock, title: "Entregas programadas", text: "Calendario de entregas alineado a su operación." },
  { icon: TrendingUp, title: "Seguimiento comercial", text: "Reportes y acompañamiento postventa continuo." },
];

export default function Solutions() {
  return (
    <section id="soluciones" className="relative py-24 md:py-36 bg-ecmist" data-testid="solutions-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-[1fr_1fr] gap-16 items-end mb-16">
          <SectionHeading
            num="06"
            chapter="Soluciones para Retail"
            id="soluciones"
            title={<>Diseñadas para operar <span className="text-ecamber">cadenas</span></>}
            sub="Desde la apertura de una tienda hasta el reabasto de cientos de sucursales."
          />
          <Reveal delay={0.15}>
            <div className="relative clip-frame overflow-hidden h-64 lg:h-72 group">
              <img
                src="https://static.prod-images.emergentagent.com/jobs/24a333bc-2e7e-46b7-92b0-448b1e3d79eb/images/9e9d535c496f87205b6b4e37a76adf10c64daecd6c331d8d33833be7d90adb94.jpeg"
                alt="Tienda de tecnología moderna"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ecdeep/70 via-transparent to-transparent" />
              <p className="absolute bottom-5 left-6 text-white text-sm font-semibold tracking-wide">Retail tecnológico en operación</p>
            </div>
          </Reveal>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((it, i) => (
            <Reveal key={it.title} delay={(i % 3) * 0.08}>
              <div className="card-lift h-full bg-white border border-ecnavy/10 rounded-2xl p-8 soft-shadow" data-testid={`solution-card-${i}`}>
                <span className="icon-tile inline-flex h-12 w-12 rounded-xl bg-ecnavy/5 text-ecnavy items-center justify-center mb-6">
                  <it.icon size={22} strokeWidth={2} />
                </span>
                <h3 className="font-display text-lg font-semibold text-ecdeep">{it.title}</h3>
                <p className="mt-2.5 text-sm text-slate-600 leading-relaxed">{it.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
